import Base2Repository from "./base2.repository";
import { GenericPersistence } from "core/data/persistence";
import { GenericService } from "core/data/service";

class DevolutionSellableReportRepository extends Base2Repository {
  getPersistenceProvider() {
    return new GenericPersistence(this.getEntityIdentifier());
  }

  getServiceProvider() {
    return new GenericService({});
  }

  async getDevolutionSellabletReport(filters) {
    const result = await this.get("/v1/devolutions_sellables_reports", {
      from: filters.from,
      to: filters.to,
      sellable_uuid: filters.sellable_uuid,
      credit_coupon_code: filters.devolutionCode,
      page: filters.page,
      count: 25,
      order: filters.order
    });
    return result;
  }

  async getDevolutionSellabletGroupReport(filters) {
    const result = await this.get("/v1/devolutions_sellables_reports_group", {
      from: filters.from,
      to: filters.to,
      sellable_uuid: filters.sellable_uuid,
      credit_coupon_code: filters.devolutionCode,
      page: filters.page,
      count: 25,
      order: filters.order
    });
    return result;
  }

  async getDevolutionSellableTotal(filters) {
    const result = await this.get("/v1/devolutions_sellables_reports_totals", {
      from: filters.from,
      to: filters.to,
      sellable_uuid: filters.sellable_uuid,
      credit_coupon_code: filters.devolutionCode
    });
    return result;
  }

  async getDevolutionSellableReportCSV(filters) {
    const result = await this.get("/v1/devolutions_sellables_reports", {
      from: filters.from,
      to: filters.to,
      salesman_uuid: filters.salesman_uuid,
      sellable_uuid: filters.sellable_uuid,
      credit_coupon_code: filters.devolutionCode,
      page: 1,
      count: 999999999,
      order: filters.order
    });
    return result;
  }
}

export default new DevolutionSellableReportRepository();



// WEBPACK FOOTER //
// ./src/core/repository/devolution-sellable-report.repository.js